var map = {
	"./affiliates/12x.svg": 148,
	"./affiliates/affiliate-main-image.png": 149,
	"./affiliates/affiliates-form-sent.svg": 150,
	"./affiliates/feature-1.jpg": 151,
	"./affiliates/feature-2.jpg": 152,
	"./affiliates/feature-3.jpg": 153,
	"./backgrounds/blog-header-image-glass-2.png": 154,
	"./backgrounds/blog-header-image.png": 155,
	"./backgrounds/credit-card-world-map-background.png": 156,
	"./backgrounds/glin-symbol-black.png": 157,
	"./backgrounds/glin-symbol-primary.png": 158,
	"./backgrounds/glin-symbol-secondary.png": 159,
	"./backgrounds/glin-symbol-white.png": 160,
	"./bitmap/_main-image.png": 161,
	"./bitmap/cloud-flare-badge.png": 162,
	"./bitmap/main-image-2.png": 163,
	"./bitmap/main-image.png": 164,
	"./bitmap/payment-success-img.svg": 165,
	"./bitmap/smartphone-in-the-mall.png": 166,
	"./carts/empty.svg": 167,
	"./como_funciona/choose-cards.png": 168,
	"./como_funciona/choose-items.png": 169,
	"./como_funciona/delivery.png": 170,
	"./como_funciona/order.png": 171,
	"./como_funciona/payment.png": 172,
	"./como_funciona/tutorial-buy.svg": 173,
	"./como_funciona/tutorial-check-value.svg": 174,
	"./como_funciona/tutorial-pay.svg": 175,
	"./como_funciona/tutorial-select-card.svg": 176,
	"./favicon/primary/android-icon-144x144.png": 177,
	"./favicon/primary/android-icon-192x192.png": 178,
	"./favicon/primary/android-icon-36x36.png": 179,
	"./favicon/primary/android-icon-48x48.png": 180,
	"./favicon/primary/android-icon-72x72.png": 181,
	"./favicon/primary/android-icon-96x96.png": 182,
	"./favicon/primary/apple-icon-114x114.png": 183,
	"./favicon/primary/apple-icon-120x120.png": 184,
	"./favicon/primary/apple-icon-144x144.png": 185,
	"./favicon/primary/apple-icon-152x152.png": 186,
	"./favicon/primary/apple-icon-180x180.png": 187,
	"./favicon/primary/apple-icon-57x57.png": 188,
	"./favicon/primary/apple-icon-60x60.png": 189,
	"./favicon/primary/apple-icon-72x72.png": 190,
	"./favicon/primary/apple-icon-76x76.png": 191,
	"./favicon/primary/apple-icon-precomposed.png": 192,
	"./favicon/primary/apple-icon.png": 193,
	"./favicon/primary/favicon-16x16.png": 194,
	"./favicon/primary/favicon-32x32.png": 195,
	"./favicon/primary/favicon-96x96.png": 196,
	"./favicon/primary/ms-icon-144x144.png": 197,
	"./favicon/primary/ms-icon-150x150.png": 198,
	"./favicon/primary/ms-icon-310x310.png": 199,
	"./favicon/primary/ms-icon-70x70.png": 200,
	"./favicon/secondary/android-icon-144x144.png": 201,
	"./favicon/secondary/android-icon-192x192.png": 202,
	"./favicon/secondary/android-icon-36x36.png": 203,
	"./favicon/secondary/android-icon-48x48.png": 204,
	"./favicon/secondary/android-icon-72x72.png": 205,
	"./favicon/secondary/android-icon-96x96.png": 206,
	"./favicon/secondary/apple-icon-114x114.png": 207,
	"./favicon/secondary/apple-icon-120x120.png": 208,
	"./favicon/secondary/apple-icon-144x144.png": 209,
	"./favicon/secondary/apple-icon-152x152.png": 210,
	"./favicon/secondary/apple-icon-180x180.png": 211,
	"./favicon/secondary/apple-icon-57x57.png": 212,
	"./favicon/secondary/apple-icon-60x60.png": 213,
	"./favicon/secondary/apple-icon-72x72.png": 214,
	"./favicon/secondary/apple-icon-76x76.png": 215,
	"./favicon/secondary/apple-icon-precomposed.png": 216,
	"./favicon/secondary/apple-icon.png": 217,
	"./favicon/secondary/favicon-16x16.png": 218,
	"./favicon/secondary/favicon-32x32.png": 219,
	"./favicon/secondary/favicon-96x96.png": 220,
	"./favicon/secondary/ms-icon-144x144.png": 221,
	"./favicon/secondary/ms-icon-150x150.png": 222,
	"./favicon/secondary/ms-icon-310x310.png": 223,
	"./favicon/secondary/ms-icon-70x70.png": 224,
	"./fb-logo.png": 225,
	"./giftcards/img-gift-success.svg": 226,
	"./giftcards/select-a-giftcard.svg": 227,
	"./google-logo.png": 228,
	"./icons/adidas-logo.svg": 229,
	"./icons/check-circle-solid.svg": 230,
	"./icons/icon-add-store.svg": 231,
	"./icons/icon-card.svg": 232,
	"./icons/icon-error-large.svg": 233,
	"./icons/icon-flag-br.svg": 234,
	"./icons/icon-flag-us.svg": 235,
	"./icons/icon-mp.svg": 236,
	"./icons/icon-pending-large.svg": 237,
	"./icons/icon-pix.svg": 238,
	"./icons/icon-simulator-color.svg": 239,
	"./icons/icon-simulator-modal.svg": 240,
	"./icons/icon-simulator.svg": 241,
	"./icons/icon-success-large.svg": 242,
	"./icons/icon-tawk.svg": 243,
	"./icons/icon-ted.svg": 244,
	"./icons/mp-logo-black.svg": 245,
	"./icons/mp-symbol.svg": 246,
	"./icons/pix-logo-black.svg": 247,
	"./icons/pix-logo-blue.svg": 248,
	"./icons/store_categories/icon-store-category-0.svg": 249,
	"./icons/store_categories/icon-store-category-1.svg": 250,
	"./icons/store_categories/icon-store-category-2.svg": 251,
	"./icons/store_categories/icon-store-category-3.svg": 252,
	"./icons/store_categories/icon-store-no-icon.svg": 253,
	"./icons/times-solid.svg": 254,
	"./logos/glinblack-logo-mockup-card.svg": 255,
	"./logos/glincard-white.svg": 256,
	"./logos/logo-glin-og.jpg": 257,
	"./logos/logo-glin-primary.svg": 258,
	"./logos/logo-glin-santa-claus.svg": 259,
	"./logos/logo-glin-slogan-white.svg": 260,
	"./logos/logo-glin-white.svg": 261,
	"./opnioes/testmonial-lattes.png": 262,
	"./opnioes/testmonial-vinicius-ferreira.png": 263,
	"./os_cara/eduardo-old.jpg": 264,
	"./os_cara/eduardo.png": 265,
	"./os_cara/glin-eduardo.jpg": 266,
	"./os_cara/glin-igor.jpg": 267,
	"./os_cara/glin-pedro.jpg": 268,
	"./os_cara/igor.png": 269,
	"./parceiros_pagamentos/american-logo.svg": 270,
	"./parceiros_pagamentos/banco-inter-logo.svg": 271,
	"./parceiros_pagamentos/banco-itau-logo.svg": 272,
	"./parceiros_pagamentos/caixa-logo.svg": 273,
	"./parceiros_pagamentos/cartao-caixa.svg": 274,
	"./parceiros_pagamentos/cartoes-e-MP.png": 275,
	"./parceiros_pagamentos/dinners-logo.svg": 276,
	"./parceiros_pagamentos/elo-logo.svg": 277,
	"./parceiros_pagamentos/generic-card.svg": 278,
	"./parceiros_pagamentos/hypercard-logo.svg": 279,
	"./parceiros_pagamentos/inter_menor.png": 280,
	"./parceiros_pagamentos/mastercard-logo.svg": 281,
	"./parceiros_pagamentos/mercado-pago-logo.svg": 282,
	"./parceiros_pagamentos/neon_menor.png": 283,
	"./parceiros_pagamentos/resized/american-logo.svg": 284,
	"./parceiros_pagamentos/resized/banco-inter-logo.svg": 285,
	"./parceiros_pagamentos/resized/banco-itau-logo.svg": 286,
	"./parceiros_pagamentos/resized/elo-logo.svg": 287,
	"./parceiros_pagamentos/resized/hipercard-logo.svg": 288,
	"./parceiros_pagamentos/resized/mastercard-logo.svg": 289,
	"./parceiros_pagamentos/resized/mercado-pago-logo.svg": 290,
	"./parceiros_pagamentos/resized/pix-logo.png": 291,
	"./parceiros_pagamentos/resized/truora-badge.svg": 292,
	"./parceiros_pagamentos/resized/truora-big.svg": 293,
	"./parceiros_pagamentos/resized/truora-cloudflare.svg": 294,
	"./parceiros_pagamentos/resized/truora-logo.svg": 295,
	"./parceiros_pagamentos/resized/truora-shield.svg": 296,
	"./parceiros_pagamentos/resized/visa-logo.svg": 297,
	"./parceiros_pagamentos/visa-logo.svg": 298,
	"./partners_page/personal_shopper_bags.png": 299,
	"./partners_page/personal_shopper_bags_v0.png": 300,
	"./pix/glin_qr_code.png": 301,
	"./pix/pix-logo.png": 302,
	"./porque/art-cashback.svg": 303,
	"./porque/art-frete.svg": 304,
	"./porque/art-instant-purchase.svg": 305,
	"./porque/art-pague-em-reais.svg": 306,
	"./porque/art-parcele-12x.svg": 307,
	"./porque/art-security-privacity.svg": 308,
	"./porque/art-tax.svg": 309,
	"./porque/art-ted.svg": 310,
	"./qrcode.png": 311,
	"./whatsapp-logo.png": 312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;